/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderFormSchemaFactory, FormRootSchema, FormStateSchema } from '@gh/builder-shared';
import { FormState, whenEditMode } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { JobRfq } from '../../../resources/job-details-tab/job-details-tab-model';

@Injectable()
export class JobDetailsRfqTabFormState extends FormState<JobRfq> {

  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  protected buildSchema(value: JobRfq, { root }: FormStateSchema): FormRootSchema {
    return root({
      mode: FormMode.ViewMode,
      enabled: whenEditMode(),
      optimisticLock: true,
      children: {
        inspectedDate: { enabled: false },
        isInspected: { enabled: false },
        inspections: void 0,
        rfqMemo: { enabled: false },
        isQuickJob: void 0,
      },
    });
  }
}
